/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import request from '../request';
export function getSessionUser(data) {
  return request.get( // 获取用户session
  '/v2/sessionUser/info', {
    params: _objectSpread(_objectSpread({}, data), {}, {
      t: new Date().getTime()
    })
  });
}
export function pseudoLogin(data) {
  return request.get( // 伪登录
  '/index', {
    params: data
  });
}
export function operLog(data) {
  return request.get( // 企业访问记录
  '/operlog/login', {
    params: data
  });
}
export function version(data) {
  return request.get( // 版本更新
  '/product/version/1', {
    params: data
  });
}
export function isQuickDeploy(data) {
  return request.get( // 是否快速部署
  '/schema/isQuickDeploy', {
    params: data
  });
} // 修改用户工作状态

export function schemaInstall(data) {
  return request.post('/schema/install', data);
}
export function schemaProgress(data) {
  return request.get( // 是否快速部署
  '/schema/progress', {
    params: data
  });
}
export function schemaList(data) {
  return request.get( // 是否快速部署
  '/schema/list', {
    params: data
  });
}
export function getOssPolicy(data) {
  return request.get('/upload/getOssPolicy', {
    params: data,
    headers: {
      timeout: 10 * 1000
    }
  });
}